import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import {
    rulesEngineSelectors,
    characterActions,
    Constants,
    HitPointInfo,
    RuleData,
} from '@dndbeyond/character-rules-engine/es';

import { sidebarActions } from '../../../Shared/actions';
import { appEnvSelectors } from '../../../Shared/selectors';
import { PaneComponentEnum } from '../../../Shared/utils';
import StatusSummaryMobile from '../../components/StatusSummaryMobile';
import { SheetAppState } from '../../typings';
import CharacterHeaderInfo from '../CharacterHeaderInfo';

interface Props extends DispatchProp {
    hitPointInfo: HitPointInfo;
    fails: number;
    successes: number;
    deathCause: Constants.DeathCauseEnum;
    inspiration: boolean;
    ruleData: RuleData;
    isReadonly: boolean;
}
class CharacterHeaderMobile extends React.PureComponent<Props> {
    handleHealthSummaryClick = (): void => {
        const { dispatch, isReadonly } = this.props;

        if (!isReadonly) {
            dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.HEALTH_MANAGE));
        }
    };

    handleInspirationClick = (): void => {
        const { inspiration, dispatch } = this.props;

        dispatch(characterActions.inspirationSet(!inspiration));
    };

    render() {
        const { hitPointInfo, fails, successes, deathCause, inspiration, ruleData, isReadonly } = this.props;

        return (
            <div className="ct-character-header-mobile">
                <div className="ct-character-header-mobile__group ct-character-header-mobile__group-tidbits">
                    <CharacterHeaderInfo />
                </div>
                <div className="ct-character-header-mobile__group ct-character-header-mobile__group--gap" />
                <div className="ct-character-header-mobile__group ct-character-header-mobile__group--summary">
                    <StatusSummaryMobile
                        hitPointInfo={hitPointInfo}
                        fails={fails}
                        successes={successes}
                        deathCause={deathCause}
                        inspiration={inspiration}
                        ruleData={ruleData}
                        onHealthClick={this.handleHealthSummaryClick}
                        onInspirationClick={this.handleInspirationClick}
                        isInteractive={!isReadonly}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        hitPointInfo: rulesEngineSelectors.getHitPointInfo(state),
        fails: rulesEngineSelectors.getDeathSavesFailCount(state),
        successes: rulesEngineSelectors.getDeathSavesSuccessCount(state),
        inspiration: rulesEngineSelectors.getInspiration(state),
        ruleData: rulesEngineSelectors.getRuleData(state),
        deathCause: rulesEngineSelectors.getDeathCause(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
    };
}

export default connect(mapStateToProps)(CharacterHeaderMobile);
